var render = function render(){var _vm=this,_c=_vm._self._c;return _c('back-to-top',{staticClass:"back-to-top",attrs:{"right":"30px","visibleoffset":"1400"}},[_c('div',{staticClass:"back-to-top__circle"},[_c('span',{staticClass:"icon-arrow-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }